import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.handleClick
props.disabled
props.inline
props.circle
props.outline
props.aura (no background until hover)

props.badgeContent
props.badgeDot

props.iconOnly
props.iconAndTitle
props.titleAndIcon

size

//
// TODO

rems={1}
2 je idealan za btn oko 2rem tj. 32px gde je font ikonice 20px a font teksta 14px.
1.5 je idealan za btn 1.5rem tj. 24px gde je font ikonice 16px a font teksta 14px.
1 je idealan za btn 1rem tj. 16px gde je font ikonice 12px a font teksta 12px.



props.extraClass
*/

const UniBadge = (props) => {
  let _clickable = false;
  let handleClick = null;
  let _has_icon = false;
  let _has_title = false;
  let _abbr_on_title_only = false;
  let _tooltip = false;
  let _badge_content = false;
  let _is_badge_dot = false;
  let cl = 'unicompo-badge';
  let jsxTitle = null;
  // let jsxFontAwsome = null;
  let jsxIcon = null;
  //
  if (props.disabled === true) {
    cl += ' unicompo-badge--disabled';
    // handleClick = null;
  } else {
    if (typeof props.handleClick === 'function') {
      handleClick = props.handleClick;
      _clickable = true;
      cl += ' unicompo-badge--clickable';
    }
  }

  //
  // variants
  if (props.inline) {
    cl += ' unicompo-badge--inline';
  }

  //
  // badge
  if ((typeof props.badgeContent === 'string' && props.badgeContent !== '') || typeof props.badgeContent === 'number') {
    _badge_content = props.badgeContent;
  }
  if (props.badgeDot === true) {
    _is_badge_dot = true;
    _badge_content = false;
  }

  //
  if (typeof props.extraClass === 'string' && props.extraClass !== '') {
    cl += ' ' + props.extraClass;
  }

  return (
    <>
      {
        _badge_content && (
          <span className="unicompo-badge">{_badge_content}</span>
        )
      }
      {
        _is_badge_dot && (
          <span className="unicompo-badge unicompo-badge--dot"></span>
        )
      }
    </>
  );
};

export default UniBadge;